export enum ProspectStatusEnum {
  Inactive = 0,
  Active = 1,
  Converted = 99,
}
